import { Box, Button, chakra, Text } from "@chakra-ui/react";

export const IconCircle = chakra(Box, {
  baseStyle: {
    bg: "blue.50",
    borderRadius: "full",
    p: "4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const StyledButton = chakra(Button, {
  baseStyle: {
    border: "1px solid #1819B4",
    w: "219px",
    fontSize: "14px",
    fontWeight: "500",
    h: "44px",
    borderRadius: "md",
    px: "6",
  },
});

export const StyledText = chakra(Text, {
  baseStyle: {
    fontSize: "md",
    color: "#5C6670",
    fontWeight: "500",
    textAlign: "center",
  },
});
